<template>
  <div class="gaokao-study">
    <div class="study-main" v-loading="unitlessonlistLoading">
      <template
        v-if="
          (bookStatus != 1 || isRxStudyCard != 0 || isStudyCard != 0) &&
          unitlessonlist.unit.length
        "
      >
        <div class="study-main-directory">
          <div
            class="directory-title"
            :class="{ 'directory-title-book16': bookId == 10016 }"
          >
            {{
              bookId == 10016
                ? unitlessonlist.name
                : bookId == 10004 || bookId == 10005 || bookId == 10006
                ? unitlessonlist.name.substring(unitlessonlist.name.length - 6)
                : unitlessonlist.name.substring(unitlessonlist.name.length - 4)
            }}
          </div>
          <div class="unitlesson-list">
            <div
              class="unitlessonlist_unit"
              v-for="(unit, index) in unitlessonlist.unit"
              :key="index"
            >
              <div class="unitlessonlist_unit_name">
                {{ unit.nameContent }}
              </div>
              <div
                class="unitlessonlist_lesson"
                v-for="(lesson, lessonIndex) in unit.lesson"
                :key="lessonIndex"
              >
                <div class="unitlessonlist_lesson_name">
                  {{ lesson.lessonName }}
                </div>

                <template
                  v-if="
                    unitlessonlist.folderName == 10007 ||
                    unitlessonlist.folderName == 10008
                  "
                >
                  <div
                    v-for="(exercise, exerciseIndex) in lesson.exercises"
                    :key="exerciseIndex"
                    class="unitlessonlist_lesson_child"
                    :class="
                      lessonId == lesson.lessonId &&
                      exercise_index == exerciseIndex
                        ? 'unitlessonlist_lesson_child_active'
                        : ''
                    "
                    @click="
                      getbookexerciseslist(
                        index,
                        lessonIndex,
                        exerciseIndex,
                        lesson.lessonId
                      )
                    "
                  >
                    <img
                      class="unitlessonlist_lesson_child_icon"
                      src="~@/assets/images/icon_headset.png"
                    />{{
                      unitlessonlist.folderName == 10008
                        ? "模拟练习"
                        : unit.nameContent === "第一部分 分类训练"
                        ? exercise.exercisesTitle
                        : "模拟练习"
                    }}
                  </div>
                </template>

                <template
                  v-if="
                    unitlessonlist.folderName != 10007 &&
                    unitlessonlist.folderName != 10008
                  "
                >
                  <div
                    v-for="(exercise, exerciseIndex) in lesson.exercises"
                    :key="exerciseIndex"
                    class="unitlessonlist_lesson_child"
                    :class="
                      lessonId == lesson.lessonId &&
                      exercise_index == exerciseIndex
                        ? 'unitlessonlist_lesson_child_active'
                        : ''
                    "
                    @click="
                      getbookexerciseslist(
                        index,
                        lessonIndex,
                        exerciseIndex,
                        lesson.lessonId
                      )
                    "
                  >
                    <img
                      class="unitlessonlist_lesson_child_icon"
                      src="~@/assets/images/icon_headset.png"
                    />{{ exercise.exercisesTitle }}
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>

        <div class="study-main-content">
          <div class="index_r_t">
            <div class="index_r_t_box">
              <!-- <div class="index_r_t_box" v-show="activeBook"> -->
              <!-- <img
                class="index_r_t_bookIco"
                :src="activeBook.book_ico"
                alt=""
              /> -->
              <img class="index_r_t_bookIco" :src="bookIcon" alt="" />
              <img
                class="index_r_t_audioCd"
                :class="isPlay ? 'index_r_t_audioCd_animation' : ''"
                src="~@/assets/images/audio_cd.png"
                alt=""
              />
            </div>
          </div>
        </div>
      </template>

      <div class="unitlessonlist_not_data" v-else>
        <img src="@/assets/images/not_bookData.png" alt="暂无教材" />
      </div>
    </div>

    <div class="study-player">
      <div class="index_r_b_not_audio" v-if="!audioId"></div>
      <div class="index_r_b_one">
        <div class="index_r_b_one_l">
          <el-dropdown @command="playbackRateChange">
            <span class="el-dropdown-link">
              {{ playbackRateText }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="0.5">0.5</el-dropdown-item>
              <el-dropdown-item command="1.0">1.0</el-dropdown-item>
              <el-dropdown-item command="1.5">1.5</el-dropdown-item>
              <el-dropdown-item command="2.0">2.0</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="index_r_b_one_c">
          <div class="index_r_b_one_c_btn1">
            <i class="iconfont icon-prev" @click="prevSong"></i>
          </div>
          <div class="index_r_b_one_c_btn2">
            <i class="iconfont icon-pause2" v-show="isPlay" @click="pause"></i>
            <i class="iconfont icon-bofang" v-show="!isPlay" @click="play"></i>
          </div>
          <div class="index_r_b_one_c_btn3">
            <i class="iconfont icon-next" @click="nextSong"></i>
          </div>
        </div>
        <div class="index_r_b_one_r">
          <div v-show="answer && answer.length > 0" @click="showAnswer">
            答案
          </div>
        </div>
      </div>
      <div class="index_r_b_two">
        <div class="index_r_b_two_l">
          <drag-progress
            :min="0"
            :max="100"
            :value="(currentTime / audioTime) * 100"
            @input="dragProgressChange"
          ></drag-progress>
          <div class="index_r_b_two_l_time">
            {{ formatDateHms(currentTime) }}
          </div>
        </div>
        <div class="index_r_b_two_r">
          <div class="index_r_b_two_r_loop" @click="audioLoopChange">
            <i class="iconfont icon-circulate3" v-show="audioLoop == 2"></i>
            <i class="iconfont icon-circulate4" v-show="audioLoop == 1"></i>
          </div>
          <div class="index_r_b_two_r_time">
            {{ formatDateHms(audioTime) }}
          </div>
        </div>
      </div>
    </div>
    <audio
      ref="myAudio"
      class="index_r_b_audio"
      id="audio"
      src=""
      controls
      width="30px"
      @canplay="audioCanplay"
      @timeupdate="audioTimeupdate"
      @play="audioPlay"
      @pause="audioPause"
      @ended="audioEnded"
      style="display: none"
    ></audio>
  </div>
</template>

<script>
import DragProgress from "@/components/DragProgress/Index.vue";
import {
  getGwBookUnitLessonListDB,
  getGwBookExercisesListDB,
} from "@/interface";

import { bookSort } from "@/utils/bookManage.js";
export default {
  components: {
    DragProgress,
  },
  data() {
    return {
      bookId: "",
      bookStatus: 1,
      bookIcon: "",
      isWatchCurBook: false,
      isStudyCard: 0,
      isRxStudyCard: 0,
      unitlessonlistLoading: false,
      unitlessonlist: {
        name: "",
        unit: [],
      },
      unitIndex: 0,
      lessonId: "",
      lesson_type: 0, //1-真题解析 2-模拟练习
      lesson_index: 0,
      exercise_index: 0,
      exercisesId: 0,
      exercisesList: [],
      exerciseslistLoading: false,
      //音乐播放
      isPlay: false,
      audioId: "", //播放音乐id
      currentTime: 0,
      audioTime: 0, //时长
      playbackRate: "1.0",
      playbackRateText: "1.0x",
      answer: "", //答案
      audioLoop: 1, //循环模式 1 播放完毕结束 2循环播放
    };
  },
  beforeRouteLeave(to, from, next) {
    this.$store.dispatch("choiceCurBook", {}).then(() => {});
    next();
  },
  computed: {
    curBook: (vm) => vm.$store.getters.curBook,
  },
  watch: {
    bookId: {
      handler(newVl) {
        if (!newVl) return;
        this.bookIcon = require(`@/assets/images/book_cover/${bookSort[newVl]?.imgName}`);
      },
      immediate: true,
    },
    curBook: {
      handler(newVl) {
        if (this.isWatchCurBook) {
          this.handleInit(newVl);
        }
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    this.handleInit(this.curBook);
  },
  mounted() {},
  methods: {
    handleInit(cur_book) {
      this.currentTime = 0;
      this.answer = null;
      this.unitlessonlist = {
        name: "",
        unit: [],
      };
      this.audioId = "";

      let curBookC = cur_book || {};
      if (!Object.keys(curBookC).length) {
        if (sessionStorage.getItem("rypc_book")) {
          curBookC = JSON.parse(sessionStorage.getItem("rypc_book"));
        } else {
          this.$router.replace({ path: "/gaokao" });
          return;
        }
      }
      this.isWatchCurBook = true;
      const {
        book_id: bookId,
        activation_status: bookStatus,
        isStudyCard,
        isRxStudyCard,
      } = curBookC;
      if (bookId) {
        this.bookId = bookId;
        // this.bookStatus = bookStatus || 1;
        this.bookStatus = bookStatus;
        this.isStudyCard = isStudyCard;
        this.isRxStudyCard = isRxStudyCard;
      }

      this.getBookDirectory();
    },
    //获取书籍目录
    getBookDirectory() {
      const params = {
        book_id: this.bookId,
      };
      this.unitlessonlistLoading = true;
      getGwBookUnitLessonListDB(params)
        .then((res) => {
          if (res) {
            const data = this.$aes128Decrypt(res.data);
            this.unitlessonlist = data;
            console.log("获取书籍目录", data);
            this.getbookexerciseslist(
              0,
              0,
              0,
              this.unitlessonlist.unit[0].lesson[0].lessonId
            );
          }
          this.unitlessonlistLoading = false;
        })
        .catch(() => {
          this.unitlessonlistLoading = false;
        });
    },
    //获取课程详情
    getbookexerciseslist(
      unitIndex,
      lesson_index,
      exercise_index,
      lessonId,
      autoplay
    ) {
      console.log(
        "获取课程详情",
        unitIndex,
        lesson_index,
        exercise_index,
        lessonId,
        autoplay
      );
      // if (this.lessonId == lessonId) {
      //   return;
      // }
      this.isPlay = false;
      this.answer = null;
      this.unitIndex = unitIndex;
      this.lesson_type = exercise_index;
      this.lesson_index = lesson_index;
      this.exercise_index = exercise_index;
      this.lessonId = lessonId;
      const param = {
        book_id: this.bookId,
        lesson_id: this.lessonId,
      };
      this.exerciseslistLoading = true;
      getGwBookExercisesListDB(param)
        .then((res) => {
          if (res) {
            const data = this.$aes128Decrypt(res.data);
            this.exercisesList = data.content;
            console.log("获取课程详情", param, data);
            this.audioId = data.content[this.exercise_index].mp3Id;
            this.answer = data.content[this.exercise_index].data;
            this.init(autoplay);
          }
          this.exerciseslistLoading = false;
        })
        .catch(() => {
          this.exerciseslistLoading = false;
        });
    },
    //查看答案
    showAnswer() {
      const newDatas = [];
      const h = this.$createElement;
      this.answer.forEach((item) => {
        newDatas.push(h("p", null, item.answerContent));
      });

      this.$confirm(h("div", null, newDatas), "答案", {
        showConfirmButton: false,
        cancelButtonText: "取消",
      }).catch(() => {});
    },
    /*
     * 音乐播放
     * */
    init(autoplay) {
      this.currentTime = 0;
      this.audioTime = 0;
      const userData = localStorage.getItem("rypc_userInfo");
      // eslint-disable-next-line no-undef
      console.log("播放音乐", pep, JSON.parse(userData), this.audioId);
      // eslint-disable-next-line no-undef
      pep.hls.play({
        obj_id: "audio",
        access_token: "",
        client_id: "0cab0b45-2bdd-11e8-afa6-005056ae9a1b",
        user_id: JSON.parse(userData).user_id,
        //res_id:"128400121021911647483168223",
        res_id: this.audioId, //连读
        autoplay: autoplay ? true : false, //是否自动播放
      });
      const myAudio = this.$refs.myAudio;
      myAudio.playbackRate = this.playbackRate;
    },
    //播放
    play() {
      if (this.audioId) {
        this.EndedTime = 0;
        const myAudio = this.$refs.myAudio;
        myAudio.play();
      }
    },
    //暂停
    pause() {
      if (this.audioId) {
        const myAudio = this.$refs.myAudio;
        myAudio.pause();
      }
    },
    //音频缓存完
    audioCanplay() {
      const myAudio = this.$refs.myAudio;
      this.audioTime = myAudio.duration;
      //console.log(this.audioTime)
    },
    //音频播放状态改变
    audioTimeupdate(e) {
      this.currentTime = e.target.currentTime;
      const myAudio = this.$refs.myAudio;
      const _this = this;
      setTimeout(function () {
        if (
          myAudio.currentTime <= _this.audioTime &&
          _this.isPlay &&
          _this.EndedTime == myAudio.currentTime &&
          _this.audioLoop == 2
        ) {
          _this.init(true);
        } else {
          _this.EndedTime = myAudio.currentTime;
        }
      }, 300);
    },
    //音频开始播放
    audioPlay() {
      this.isPlay = true;
    },
    //音频暂停播放
    audioPause() {
      this.isPlay = false;
    },
    //音频播放结束
    audioEnded() {
      this.isPlay = false;
      console.log(this.audioLoop);
      if (this.audioLoop == 2) {
        //顺序播放
        // this.nextSong();
        const _this = this;
        setTimeout(function () {
          //单曲循环播放
          _this.play();
        }, 300);
      } else {
        //单曲播放
      }
    },
    //上一曲
    prevSong() {
      if (!this.audioId) {
        return;
      }
      this.answer = null;

      if (0 > this.exercise_index - 1) {
        if (0 > this.lesson_index - 1) {
          if (0 > this.unitIndex - 1) {
            this.unitIndex = this.unitlessonlist.unit.length - 1;
            this.lesson_index =
              this.unitlessonlist.unit[this.unitIndex].lesson.length - 1;
            this.exercise_index =
              this.unitlessonlist.unit[this.unitIndex].lesson[this.lesson_index]
                .exercises.length - 1;
          } else {
            this.unitIndex--;
            this.lesson_index =
              this.unitlessonlist.unit[this.unitIndex].lesson.length - 1;
            this.exercise_index =
              this.unitlessonlist.unit[this.unitIndex].lesson[this.lesson_index]
                .exercises.length - 1;
          }
        } else {
          this.lesson_index--;
          this.exercise_index = this.exercisesList.length - 1;
        }
      } else {
        this.exercise_index--;
      }

      this.getbookexerciseslist(
        this.unitIndex,
        this.lesson_index,
        this.exercise_index,
        this.unitlessonlist.unit[this.unitIndex].lesson[this.lesson_index]
          .lessonId,
        true
      );
    },
    //下一曲
    nextSong() {
      if (!this.audioId) {
        return;
      }
      this.answer = null;

      if (this.exercisesList.length <= this.exercise_index + 1) {
        if (
          this.unitlessonlist.unit[this.unitIndex].lesson.length <=
          this.lesson_index + 1
        ) {
          if (this.unitlessonlist.unit.length <= this.unitIndex + 1) {
            this.unitIndex = 0;
            this.lesson_index = 0;
            this.exercise_index = 0;
          } else {
            this.unitIndex++;
            this.lesson_index = 0;
            this.exercise_index = 0;
          }
        } else {
          this.lesson_index++;
          this.exercise_index = 0;
        }
      } else {
        this.exercise_index++;
      }

      this.getbookexerciseslist(
        this.unitIndex,
        this.lesson_index,
        this.exercise_index,
        this.unitlessonlist.unit[this.unitIndex].lesson[this.lesson_index]
          .lessonId,
        true
      );
    },
    //修改播放倍速
    playbackRateChange(num) {
      if (num != this.playbackRate) {
        //console.log('修改倍速')
        const myAudio = this.$refs.myAudio;
        this.playbackRate = num;
        this.playbackRateText = num + "x";
        if (!this.audioId) {
          return;
        }
        myAudio.playbackRate = num;
      }
    },
    //修改播放循环方式
    audioLoopChange() {
      this.audioLoop = this.audioLoop == 1 ? 2 : 1;
    },
    //进度条进度改变回调
    dragProgressChange(progress) {
      if (!this.audioId) {
        return;
      }
      if (this.audioTime > 0) {
        const myAudio = this.$refs.myAudio;
        this.currentTime = (progress / 100) * this.audioTime;
        myAudio.currentTime = this.currentTime;
      }
    },
    //时间处理时分秒
    formatDateHms(time) {
      time = parseInt(time);
      const h =
        Math.floor(time / 3600) < 10
          ? "0" + Math.floor(time / 3600)
          : Math.floor(time / 3600);
      const m =
        Math.floor((time / 60) % 60) < 10
          ? "0" + Math.floor((time / 60) % 60)
          : Math.floor((time / 60) % 60);
      const s =
        Math.floor(time % 60) < 10
          ? "0" + Math.floor(time % 60)
          : Math.floor(time % 60);
      let str = "";
      if (h > 0) {
        str = h + ":" + m + ":" + s;
      } else {
        str = m + ":" + s;
      }
      return str;
    },
  },
};
</script>

<style lang="scss" scoped>
.gaokao-study {
  // border-radius: 2px;
  // background: white;
  // box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.5);
  // height: 100%;

  .study-main {
    height: 510px;
    background: url("~@/assets/images/audio_bg.jpg") no-repeat;
    background-size: 100%;
    display: flex;
    border-radius: 2px;
    box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.5);

    .study-main-directory {
      width: 220px;
      height: 100%;
      overflow-y: auto;
      &::-webkit-scrollbar {
        background-color: white;
        width: 6px;
        height: 8px;
      }
      &::-webkit-scrollbar-track {
      }
      &::-webkit-scrollbar-thumb {
        background: #ccc;
        border-radius: 3px;
      }
      &::-webkit-scrollbar-thumb:hover {
        background: #aaa;
      }
      &::-webkit-scrollbar-corner {
        background: #ccc;
      }
      .directory-title {
        color: #101010;
        background: white;
        line-height: 44px;
        height: 44px;
        font-weight: 700;
        font-size: 18px;
        text-align: center;
      }
      .directory-title-book16 {
        font-size: 12px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .unitlessonlist_unit {
        font-size: 12px;
      }
      .unitlessonlist_unit_name {
        padding: 8px 15px;
        background: #3ae6cb;
        color: #fff;
      }
      .unitlessonlist_lesson_name {
        padding: 8px 15px;
        color: #101010;
        position: relative;
      }
      .unitlessonlist_lesson_name:before {
        content: "";
        position: absolute;
        bottom: 0;
        left: 15px;
        right: 15px;
        height: 1px;
        background: #ddd;
      }
      .unitlessonlist_lesson_child {
        padding: 8px 15px 8px 60px;
        position: relative;
        color: #101010;
        cursor: pointer;
      }
      .unitlessonlist_lesson_child:hover,
      .unitlessonlist_lesson_child_active {
        background: #81ced8;
        color: #fff;
      }
      .unitlessonlist_lesson_child_icon {
        position: absolute;
        left: 35px;
        top: 7px;
        width: 20px;
        height: 20px;
      }
    }
    .study-main-content {
      flex: 1;
      height: 100%;
      overflow: hidden;
    }
  }

  .study-player {
    margin-top: 10px;
    background: #fff;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.5);
    height: 80px;
    position: relative;
  }

  .unitlessonlist_not_data {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .unitlessonlist_not_data img {
    height: 140px;
    width: auto;
    max-width: 100%;
  }

  .index_r_t {
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .index_r_t_box {
    position: relative;
    width: 30%;
    font-size: 0;
    margin: 0 auto;
    height: auto;
  }
  .index_r_t_bookIco {
    width: 70%;
    height: auto;
    position: relative;
    z-index: 2;
  }
  .index_r_t_audioCd {
    width: 63%;
    height: auto;
    position: absolute;
    top: 16%;
    right: 0;
    z-index: 1;
  }
  .index_r_t_audioCd_animation {
    animation: rotate 20s linear infinite;
  }
  @keyframes rotate {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
  .index_r_t_not_data {
    text-align: center;
  }
  .index_r_t_not_data img {
    width: 30%;
    height: auto;
    max-width: 100%;
  }
  .index_r_b_not_audio {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 1000;
    background: rgba(145, 145, 145, 0.7);
    cursor: not-allowed;
  }
  .index_r_b_one {
    height: 40px;
    line-height: 40px;
    display: -webkit-flex; /* 新版本语法: Chrome 21+ */
    display: flex; /* 新版本语法: Opera 12.1, Firefox 22+ */
    display: -webkit-box; /* 老版本语法: Safari, iOS, Android browser, older WebKit browsers. */
    display: -moz-box; /* 老版本语法: Firefox (buggy) */
    display: -ms-flexbox; /* 混合版本语法: IE 10 */
  }
  .index_r_b_one_l,
  .index_r_b_one_r {
    display: inline-block;
    vertical-align: top;
    width: 100px;
    text-align: center;
  }
  .index_r_b_one_r {
    cursor: pointer;
  }
  .index_r_b_one_r:hover {
    opacity: 0.7;
  }
  .index_r_b_one_c {
    -webkit-flex: 1; /* Chrome */
    -ms-flex: 1; /* IE 10 */
    flex: 1; /* NEW, Spec - Opera 12.1, Firefox 20+ */
    -webkit-box-flex: 1; /* OLD - iOS 6-, Safari 3.1-6 */
    -moz-box-flex: 1; /* OLD - Firefox 19- */
  }
  .index_r_b_one_c_btn1 {
    display: inline-block;
    vertical-align: top;
    width: 33.33%;
    text-align: right;
  }
  .index_r_b_one_c_btn1 .iconfont,
  .index_r_b_one_c_btn3 .iconfont {
    font-size: 24px;
    cursor: pointer;
  }
  .index_r_b_one_c_btn2 {
    display: inline-block;
    vertical-align: top;
    width: 33.33%;
    text-align: center;
  }
  .index_r_b_one_c_btn2 .iconfont {
    font-size: 34px;
    cursor: pointer;
    color: #ffa200;
  }
  .index_r_b_one_c_btn3 {
    display: inline-block;
    vertical-align: top;
    width: 33.33%;
    text-align: left;
  }
  .index_r_b_one_c_btn1 .iconfont:hover,
  .index_r_b_one_c_btn3 .iconfont:hover,
  .index_r_b_one_c_btn2 .iconfont:hover {
    opacity: 0.7;
  }
  .index_r_b_two {
    padding: 0 10px;
    display: -webkit-flex; /* 新版本语法: Chrome 21+ */
    display: flex; /* 新版本语法: Opera 12.1, Firefox 22+ */
    display: -webkit-box; /* 老版本语法: Safari, iOS, Android browser, older WebKit browsers. */
    display: -moz-box; /* 老版本语法: Firefox (buggy) */
    display: -ms-flexbox; /* 混合版本语法: IE 10 */
  }
  .index_r_b_two_l {
    -webkit-flex: 1; /* Chrome */
    -ms-flex: 1; /* IE 10 */
    flex: 1; /* NEW, Spec - Opera 12.1, Firefox 20+ */
    -webkit-box-flex: 1; /* OLD - iOS 6-, Safari 3.1-6 */
    -moz-box-flex: 1; /* OLD - Firefox 19- */
  }
  .index_r_b_two_l_time,
  .index_r_b_two_r_time {
    color: #999;
    font-size: 12px;
    height: 20px;
  }
  .index_r_b_two_r {
    width: 80px;
    text-align: center;
  }
  .index_r_b_two_r_loop {
    cursor: pointer;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .index_r_b_two_r_loop .iconfont {
    color: #000;
    font-size: 20px;
    line-height: 1;
  }
  .index_r_b_two_r_loop:hover {
    opacity: 0.7;
  }
}

// 移动端响应式样式
@media (max-width: 1024px) {
  .gaokao-study {
    position: relative !important;
    min-height: 100vh !important;

    .study-main {
      height: calc(100vh - 150px) !important;
      min-height: calc(100vh - 150px) !important;
      flex-direction: column !important;
      background-size: cover !important;
      background-position: center !important;
      border-radius: 8px 8px 0 0 !important;
      overflow: hidden !important;

      .study-main-directory {
        width: 100% !important;
        height: calc(100vh - 150px - 120px) !important;
        min-height: 200px !important;
        order: 2 !important;
        background: rgba(255, 255, 255, 0.95) !important;
        backdrop-filter: blur(10px) !important;
        border-top: 1px solid #eee !important;
        flex: 1 !important;
        overflow-y: auto !important;

        .directory-title {
          font-size: 16px !important;
          line-height: 40px !important;
          height: 40px !important;
          border-radius: 0 0 8px 8px !important;
        }

        .unitlessonlist_unit {
          font-size: 13px !important;

          .unitlessonlist_unit_name {
            padding: 12px 15px !important;
            font-size: 14px !important;
            font-weight: 600 !important;
            margin: 5px 10px !important;
            border-radius: 6px !important;
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;
          }

          .unitlessonlist_lesson_name {
            padding: 10px 15px !important;
            font-size: 13px !important;
            font-weight: 500 !important;
            margin: 3px 10px !important;
            border-radius: 4px !important;
            border-left: 3px solid #3ae6cb !important;
          }

          .unitlessonlist_lesson_name:before {
            display: none !important;
          }

          .unitlessonlist_lesson_child {
            padding: 12px 15px 12px 60px !important;
            font-size: 12px !important;
            min-height: 48px !important;
            display: flex !important;
            align-items: center !important;
            margin: 2px 10px !important;
            border-radius: 6px !important;
            transition: all 0.3s ease !important;
            background: white !important;
            border: 1px solid #e9ecef !important;

            &:hover {
              background: #f8f9fa !important;
              border-color: #dee2e6 !important;
              transform: translateX(5px) !important;
              box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
            }

            &.unitlessonlist_lesson_child_active {
              background: #81ced8 !important;
              color: white !important;
              border-color: #81ced8 !important;
              box-shadow: 0 4px 12px rgba(129, 206, 216, 0.3) !important;
              transform: translateX(8px) !important;
            }

            .unitlessonlist_lesson_child_icon {
              width: 20px !important;
              height: 20px !important;
              left: 30px !important;
              top: 50% !important;
              transform: translateY(-50%) !important;
            }
          }
        }
      }

      .study-main-content {
        order: 1 !important;
        height: 150px !important;
        min-height: 150px !important;
        max-height: 150px !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        position: relative !important;
        overflow: hidden !important;
        flex-shrink: 0 !important;

        &::before {
          content: "" !important;
          position: absolute !important;
          top: 0 !important;
          left: 0 !important;
          right: 0 !important;
          bottom: 0 !important;
          background: url("~@/assets/images/audio_bg.jpg") no-repeat center !important;
          background-size: cover !important;
          opacity: 0.3 !important;
          z-index: 1 !important;
        }

        .index_r_t {
          position: relative !important;
          z-index: 2 !important;
          width: 100% !important;
          height: 100% !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
        }

        .index_r_t_box {
          width: 60% !important;
          position: relative !important;
          height: auto !important;
          max-width: 120px !important;

          .index_r_t_bookIco {
            width: 85% !important;
            height: auto !important;
            max-width: 100% !important;
            filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.3)) !important;
          }

          .index_r_t_audioCd {
            width: 75% !important;
            height: auto !important;
            max-width: 100% !important;
            filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.3)) !important;
          }
        }
      }
    }

    .study-player {
      position: fixed !important;
      bottom: 0 !important;
      left: 0 !important;
      right: 0 !important;
      width: 100% !important;
      height: auto !important;
      min-height: 120px !important;
      max-height: 120px !important;
      margin: 0 !important;
      padding: 15px !important;
      border-radius: 12px 12px 0 0 !important;
      box-shadow: 0 -8px 25px rgba(0, 0, 0, 0.15) !important;
      flex-shrink: 0 !important;
      display: block !important;
      visibility: visible !important;
      opacity: 1 !important;
      z-index: 1000 !important;
      background: #fff !important;

      .index_r_b_one {
        height: 55px !important;
        line-height: 55px !important;

        .index_r_b_one_l,
        .index_r_b_one_r {
          width: 90px !important;
          font-size: 14px !important;
        }

        .index_r_b_one_c {
          .index_r_b_one_c_btn1,
          .index_r_b_one_c_btn3 {
            .iconfont {
              font-size: 30px !important;
              text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3) !important;
            }
          }

          .index_r_b_one_c_btn2 {
            .iconfont {
              font-size: 44px !important;
              text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3) !important;
            }
          }
        }
      }

      .index_r_b_two {
        padding: 0 15px !important;

        .index_r_b_two_l_time,
        .index_r_b_two_r_time {
          font-size: 13px !important;
          height: 26px !important;
          font-weight: 500 !important;
        }

        .index_r_b_two_r {
          width: 110px !important;

          .index_r_b_two_r_loop {
            height: 6px !important;
            display: flex !important;
            align-items: center !important;
            justify-content: center !important;

            .iconfont {
              font-size: 24px !important;
              line-height: 1 !important;
            }
          }
        }
      }
    }

    .unitlessonlist_not_data {
      img {
        height: 120px !important;
        max-width: 80% !important;
        filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.2)) !important;
      }
    }
  }
}

// 平板端响应式样式
@media (max-width: 1042px) and (min-width: 1025px) {
  .gaokao-study {
    .study-main {
      height: 450px !important;

      .study-main-directory {
        width: 200px !important;
      }
    }
  }
}

// 中等屏幕设备优化
@media (max-width: 768px) {
  .gaokao-study {
    position: relative !important;
    min-height: 100vh !important;

    .study-main {
      height: calc(100vh - 150px) !important;
      min-height: calc(100vh - 150px) !important;
      flex-direction: column !important;

      .study-main-directory {
        width: 100% !important;
        height: calc(100vh - 150px - 110px) !important;
        min-height: 200px !important;
        order: 2 !important;
        flex: 1 !important;
        overflow-y: auto !important;

        .directory-title {
          font-size: 15px !important;
          line-height: 36px !important;
          height: 36px !important;
          border-radius: 0 0 6px 6px !important;
        }

        .unitlessonlist_unit {
          .unitlessonlist_unit_name {
            padding: 10px 12px !important;
            font-size: 13px !important;
            margin: 4px 8px !important;
            border-radius: 5px !important;
          }

          .unitlessonlist_lesson_name {
            padding: 8px 12px !important;
            font-size: 12px !important;
            margin: 2px 8px !important;
            border-radius: 4px !important;
          }

          .unitlessonlist_lesson_child {
            padding: 10px 12px 10px 55px !important;
            font-size: 11px !important;
            min-height: 42px !important;
            margin: 1px 8px !important;
            border-radius: 5px !important;

            &:hover {
              transform: translateX(3px) !important;
            }

            &.unitlessonlist_lesson_child_active {
              transform: translateX(6px) !important;
            }

            .unitlessonlist_lesson_child_icon {
              width: 18px !important;
              height: 18px !important;
              left: 28px !important;
            }
          }
        }
      }

      .study-main-content {
        height: 150px !important;
        min-height: 150px !important;
        max-height: 150px !important;
        flex-shrink: 0 !important;

        .index_r_t_box {
          width: 65% !important;
          height: auto !important;
          max-width: 140px !important;

          .index_r_t_bookIco {
            width: 85% !important;
            height: auto !important;
            max-width: 100% !important;
          }

          .index_r_t_audioCd {
            width: 75% !important;
            height: auto !important;
            max-width: 100% !important;
          }
        }
      }
    }

    .study-player {
      position: fixed !important;
      bottom: 0 !important;
      left: 0 !important;
      right: 0 !important;
      width: 100% !important;
      height: auto !important;
      min-height: 110px !important;
      max-height: 110px !important;
      margin: 0 !important;
      padding: 12px !important;
      border-radius: 10px 10px 0 0 !important;
      box-shadow: 0 -8px 25px rgba(0, 0, 0, 0.15) !important;
      flex-shrink: 0 !important;
      display: block !important;
      visibility: visible !important;
      opacity: 1 !important;
      z-index: 1000 !important;
      background: #fff !important;

      .index_r_b_one {
        height: 55px !important;
        line-height: 55px !important;

        .index_r_b_one_l,
        .index_r_b_one_r {
          width: 90px !important;
          font-size: 14px !important;
        }

        .index_r_b_one_c {
          .index_r_b_one_c_btn1,
          .index_r_b_one_c_btn3 {
            .iconfont {
              font-size: 30px !important;
              text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3) !important;
            }
          }

          .index_r_b_one_c_btn2 {
            .iconfont {
              font-size: 44px !important;
              text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3) !important;
            }
          }
        }
      }

      .index_r_b_two {
        padding: 0 15px !important;

        .index_r_b_two_l_time,
        .index_r_b_two_r_time {
          font-size: 13px !important;
          height: 26px !important;
          font-weight: 500 !important;
        }

        .index_r_b_two_r {
          width: 110px !important;

          .index_r_b_two_r_loop {
            height: 6px !important;
            display: flex !important;
            align-items: center !important;
            justify-content: center !important;

            .iconfont {
              font-size: 24px !important;
              line-height: 1 !important;
            }
          }
        }
      }
    }

    .unitlessonlist_not_data {
      img {
        height: 120px !important;
        max-width: 80% !important;
        filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.2)) !important;
      }
    }
  }
}

// 小屏幕设备优化
@media (max-width: 480px) {
  .gaokao-study {
    position: relative !important;
    min-height: 100vh !important;

    .study-main {
      height: calc(100vh - 150px) !important;
      min-height: calc(100vh - 150px) !important;
      flex-direction: column !important;

      .study-main-directory {
        width: 100% !important;
        height: calc(100vh - 150px - 100px) !important;
        min-height: 150px !important;
        order: 2 !important;
        flex: 1 !important;
        overflow-y: auto !important;

        .directory-title {
          font-size: 14px !important;
          line-height: 32px !important;
          height: 32px !important;
          border-radius: 0 0 4px 4px !important;
        }

        .unitlessonlist_unit {
          .unitlessonlist_unit_name {
            padding: 8px 10px !important;
            font-size: 12px !important;
            margin: 3px 6px !important;
            border-radius: 4px !important;
          }

          .unitlessonlist_lesson_name {
            padding: 6px 10px !important;
            font-size: 11px !important;
            margin: 1px 6px !important;
            border-radius: 3px !important;
          }

          .unitlessonlist_lesson_child {
            padding: 8px 10px 8px 50px !important;
            font-size: 10px !important;
            min-height: 38px !important;
            margin: 1px 6px !important;
            border-radius: 4px !important;

            &:hover {
              transform: translateX(2px) !important;
            }

            &.unitlessonlist_lesson_child_active {
              transform: translateX(4px) !important;
            }

            .unitlessonlist_lesson_child_icon {
              width: 16px !important;
              height: 16px !important;
              left: 25px !important;
            }
          }
        }
      }

      .study-main-content {
        height: 150px !important;
        min-height: 150px !important;
        max-height: 150px !important;
        flex-shrink: 0 !important;

        .index_r_t_box {
          width: 70% !important;
          height: auto !important;
          max-width: 100px !important;

          .index_r_t_bookIco {
            width: 85% !important;
            height: auto !important;
            max-width: 100% !important;
          }

          .index_r_t_audioCd {
            width: 75% !important;
            height: auto !important;
            max-width: 100% !important;
          }
        }
      }
    }

    .study-player {
      position: fixed !important;
      bottom: 0 !important;
      left: 0 !important;
      right: 0 !important;
      width: 100% !important;
      height: auto !important;
      min-height: 100px !important;
      max-height: 100px !important;
      margin: 0 !important;
      padding: 10px !important;
      border-radius: 8px 8px 0 0 !important;
      box-shadow: 0 -8px 25px rgba(0, 0, 0, 0.15) !important;
      flex-shrink: 0 !important;
      display: block !important;
      visibility: visible !important;
      opacity: 1 !important;
      z-index: 1000 !important;
      background: #fff !important;

      .index_r_b_one {
        height: 42px !important;
        line-height: 42px !important;

        .index_r_b_one_l,
        .index_r_b_one_r {
          width: 65px !important;
          font-size: 12px !important;
        }

        .index_r_b_one_c {
          .index_r_b_one_c_btn1,
          .index_r_b_one_c_btn3 {
            .iconfont {
              font-size: 24px !important;
            }
          }

          .index_r_b_one_c_btn2 {
            .iconfont {
              font-size: 34px !important;
            }
          }
        }
      }

      .index_r_b_two {
        padding: 0 10px !important;

        .index_r_b_two_l_time,
        .index_r_b_two_r_time {
          font-size: 11px !important;
          height: 22px !important;
        }

        .index_r_b_two_r {
          width: 85px !important;

          .index_r_b_two_r_loop {
            height: 22px !important;

            .iconfont {
              font-size: 18px !important;
            }
          }
        }
      }
    }

    .unitlessonlist_not_data {
      img {
        height: 100px !important;
        max-width: 90% !important;
      }
    }
  }
}

// 触摸设备优化
@media (hover: none) and (pointer: coarse) {
  .gaokao-study {
    .study-main-directory {
      .unitlessonlist_lesson_child {
        -webkit-tap-highlight-color: rgba(129, 206, 216, 0.3);
        min-height: 44px !important;
        transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;

        &:active {
          transform: scale(0.96) translateX(3px) !important;
          background: #e8f5e8 !important;
          border-color: #4caf50 !important;
        }
      }
    }

    .study-player {
      .index_r_b_one_c {
        .index_r_b_one_c_btn1,
        .index_r_b_one_c_btn2,
        .index_r_b_one_c_btn3 {
          -webkit-tap-highlight-color: rgba(0, 0, 0, 0.1);
          min-height: 44px !important;
          min-width: 44px !important;
          transition: all 0.15s ease !important;

          &:active {
            transform: scale(0.9) !important;
            filter: brightness(1.2) !important;
          }
        }
      }

      .index_r_b_two_r_loop {
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0.1);
        height: 6px !important;
        min-height: 6px !important;
        min-width: 44px !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        transition: all 0.15s ease !important;

        &:active {
          transform: scale(0.9) !important;
          filter: brightness(1.2) !important;
        }
      }

      .index_r_b_one_l,
      .index_r_b_one_r {
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0.1);
        min-height: 44px !important;
        min-width: 44px !important;
        transition: all 0.15s ease !important;

        &:active {
          transform: scale(0.95) !important;
          opacity: 0.8 !important;
        }
      }
    }
  }
}

// 添加平滑滚动优化
@media (max-width: 1024px) {
  .gaokao-study {
    .study-main-directory {
      scroll-behavior: smooth !important;
      -webkit-overflow-scrolling: touch !important;

      &::-webkit-scrollbar {
        width: 8px !important;
        background-color: rgba(255, 255, 255, 0.8) !important;
        border-radius: 4px !important;
      }

      &::-webkit-scrollbar-track {
        background: rgba(0, 0, 0, 0.05) !important;
        border-radius: 4px !important;
      }

      &::-webkit-scrollbar-thumb {
        background: linear-gradient(135deg, #3ae6cb, #81ced8) !important;
        border-radius: 4px !important;
        border: 1px solid rgba(255, 255, 255, 0.3) !important;
      }

      &::-webkit-scrollbar-thumb:hover {
        background: linear-gradient(135deg, #2dd4b8, #6bb8c0) !important;
      }
    }
  }
}

// 添加加载状态和过渡动画
@media (max-width: 1024px) {
  .gaokao-study {
    .study-main {
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;

      .study-main-directory {
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;

        .unitlessonlist_unit {
          transition: all 0.2s ease !important;

          .unitlessonlist_unit_name {
            transition: all 0.2s ease !important;
          }

          .unitlessonlist_lesson_name {
            transition: all 0.2s ease !important;
          }

          .unitlessonlist_lesson_child {
            transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;

            .unitlessonlist_lesson_child_icon {
              transition: all 0.2s ease !important;
            }
          }
        }
      }

      .study-main-content {
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;

        .index_r_t_box {
          transition: all 0.3s ease !important;

          .index_r_t_bookIco,
          .index_r_t_audioCd {
            transition: all 0.3s ease !important;
          }
        }
      }
    }

    .study-player {
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;

      .index_r_b_one,
      .index_r_b_two {
        transition: all 0.2s ease !important;
      }
    }
  }
}

// 添加深色模式支持
@media (prefers-color-scheme: dark) {
  .gaokao-study {
    .study-main-directory {
    }
  }
}

// 确保在所有设备上都没有水平滚动
@media (max-width: 1200px) {
  .gaokao-study {
    overflow-x: hidden !important;

    .study-main,
    .study-player {
      overflow-x: hidden !important;
    }
  }
}
</style>
